<template>
    <div class="tools-tab tools-tab-time">
        <table class="table table-timepicker equal-padding">
            <tr :class="pause ? 'is-disabled' : ''">
                <!-- save() must be called as function! otherwise save(confirmed) method does not work properly! -->
                <td @click="setHour('00')" @dblclick="save()" :class="['box-hour', isHour('00') ? 'is-active' : '']">0</td>
                <td @click="setHour('01')" @dblclick="save()" :class="['box-hour', isHour('01') ? 'is-active' : '']">1</td>
                <td @click="setHour('02')" @dblclick="save()" :class="['box-hour', isHour('02') ? 'is-active' : '']">2</td>
                <td @click="setHour('03')" @dblclick="save()" :class="['box-hour', isHour('03') ? 'is-active' : '']">3</td>
                <td @click="setHour('04')" @dblclick="save()" :class="['box-hour', isHour('04') ? 'is-active' : '']">4</td>
                <td @click="setHour('05')" @dblclick="save()" :class="['box-hour', isHour('05') ? 'is-active' : '']">5</td>
                <td @click="setMinute('00')" @dblclick="save()" :class="['box-minute', isMinute('00') ? 'is-active' : '']">00</td>
            </tr>
            <tr :class="pause ? 'is-disabled' : ''">
                <td @click="setHour('06')" @dblclick="save()" :class="['box-hour', isHour('06') ? 'is-active' : '']">6</td>
                <td @click="setHour('07')" @dblclick="save()" :class="['box-hour', isHour('07') ? 'is-active' : '']">7</td>
                <td @click="setHour('08')" @dblclick="save()" :class="['box-hour', isHour('08') ? 'is-active' : '']">8</td>
                <td @click="setHour('09')" @dblclick="save()" :class="['box-hour', isHour('09') ? 'is-active' : '']">9</td>
                <td @click="setHour('10')" @dblclick="save()" :class="['box-hour', isHour('10') ? 'is-active' : '']">10</td>
                <td @click="setHour('11')" @dblclick="save()" :class="['box-hour', isHour('11') ? 'is-active' : '']">11</td>
                <td @click="setMinute('15')" @dblclick="save()" :class="['box-minute', isMinute('15') ? 'is-active' : '']">15</td>
            </tr>
            <tr :class="pause ? 'is-disabled' : ''">
                <td @click="setHour('12')" @dblclick="save()" :class="['box-hour', isHour('12') ? 'is-active' : '']">12</td>
                <td @click="setHour('13')" @dblclick="save()" :class="['box-hour', isHour('13') ? 'is-active' : '']">13</td>
                <td @click="setHour('14')" @dblclick="save()" :class="['box-hour', isHour('14') ? 'is-active' : '']">14</td>
                <td @click="setHour('15')" @dblclick="save()" :class="['box-hour', isHour('15') ? 'is-active' : '']">15</td>
                <td @click="setHour('16')" @dblclick="save()" :class="['box-hour', isHour('16') ? 'is-active' : '']">16</td>
                <td @click="setHour('17')" @dblclick="save()" :class="['box-hour', isHour('17') ? 'is-active' : '']">17</td>
                <td @click="setMinute('30')" @dblclick="save()" :class="['box-minute', isMinute('30') ? 'is-active' : '']">30</td>
            </tr>
            <tr :class="pause ? 'is-disabled' : ''">
                <td @click="setHour('18')" @dblclick="save()" :class="['box-hour', isHour('18') ? 'is-active' : '']">18</td>
                <td @click="setHour('19')" @dblclick="save()" :class="['box-hour', isHour('19') ? 'is-active' : '']">19</td>
                <td @click="setHour('20')" @dblclick="save()" :class="['box-hour', isHour('20') ? 'is-active' : '']">20</td>
                <td @click="setHour('21')" @dblclick="save()" :class="['box-hour', isHour('21') ? 'is-active' : '']">21</td>
                <td @click="setHour('22')" @dblclick="save()" :class="['box-hour', isHour('22') ? 'is-active' : '']">22</td>
                <td @click="setHour('23')" @dblclick="save()" :class="['box-hour', isHour('23') ? 'is-active' : '']">23</td>
                <td @click="setMinute('45')" @dblclick="save()" :class="['box-minute', isMinute('45') ? 'is-active' : '']">45</td>
            </tr>
            <tr class="break" v-if="pause">
                <td class="box-break" @click="pause = false"><icon name="food" /></td>
                <td @click="setPause(0)" :class="['box-break', ( ! form.break) ? 'is-active' : '']">0</td>
                <td @click="setPause(15)" :class="['box-break', (form.break == 15) ? 'is-active' : '']">15</td>
                <td @click="setPause(30)" :class="['box-break', (form.break == 30) ? 'is-active' : '']">30</td>
                <td @click="setPause(45)" :class="['box-break', (form.break == 45) ? 'is-active' : '']">45</td>
                <td @click="setPause(60)" :class="['box-break', (form.break == 60) ? 'is-active' : '']">60</td>
                <td @click="setPause(75)" :class="['box-break', (form.break == 75) ? 'is-active' : '']">75</td>
                <td @click="setPause(90)" :class="['box-break', (form.break == 90) ? 'is-active' : '']">90</td>
            </tr>
            <tr class="box-buttons">
                <td @click="remove()"><icon name="close"/></td>
                <td colspan="2" :class="['time', (type == 'from') ? 'is-active' : '']" @click="type = 'from'">
                    <div :class="['label', form.from == null ? 'is-big' : '']">{{ $t('text.from') }}</div>
                    <span v-if="form.from != null">{{ form.from }}</span>
                </td>
                <td colspan="2" :class="['time', (type == 'until') ? 'is-active' : '']" @click="type = 'until'">
                    <div :class="['label', form.until == null ? 'is-big' : '']">{{ $t('text.until') }}</div>
                    <span v-if="form.until != null">{{ form.until }}</span>
                </td>
                <td :class="['btn-break', form.break ? 'has-break' : '']" @click="pause = true; type = 'break'">
                    <div class="label" v-if="form.break">{{ $t('label.break') }}</div>
                    <span v-if="form.break">{{ form.break }}m</span>
                    <icon name="food" v-else />
                </td>
                <!-- save() must be called as function! otherwise save(confirmed) method does not work properly! -->
                <td @click="save()"><icon name="check" /></td>
            </tr>
        </table>
    </div>
</template>

<script>
import events from '../../../events/events';
import shared from '../../../pages/planning/shared';

export default
{
    name: 'Times',

    props: ['item'],

    data() {
        return {
            type: 'from',
            shared: shared.state,
            pause: false,

            form: {
                from: null,
                until: null,
                break: 0,
            }
        }
    },

    created()
    {
        this.init();
    },

    watch:
    {
        item()
        {
            this.init();
        }
    },

    computed:
    {
        hour()
        {
            return (this.type == 'from') ? this.fromHour : this.untilHour;
        },

        minute()
        {
            return (this.type == 'from') ? this.fromMinute : this.untilMinute;
        },

        fromHour()
        {
            return this.form.from && this.form.from.split(':')[0];
        },

        fromMinute()
        {
            return this.form.from && this.form.from.split(':')[1];
        },

        untilHour()
        {
            return this.form.until && this.form.until.split(':')[0];
        },

        untilMinute()
        {
            return this.form.until && this.form.until.split(':')[1];
        },

        start()
        {
            return this.$onduro.timeToNumber(this.form.from);
        },

        end()
        {
            return this.$onduro.timeToNumber(this.form.until);
        },

        timed()
        {
            return this.form.from != null && this.form.until != null;
        },
    },

    methods:
    {
        init()
        {
            if (this.item.times)
            {
                this.type = 'from';

                this.form = {
                    from: this.item.times.from,
                    until: this.item.times.until,
                    break: this.item.times.break
                };
            }
            else
            {
                this.reset();
            }
        },

        reset()
        {
            this.type = 'from';

            this.form = {
                from: null,
                until: null,
                break: 0
            };
        },

        setPause: function(value)
        {
            this.form.break = value;
            this.pause = false;
        },

        isHour: function(hour)
        {
            if (this.pause) return;

            return this.hour == hour;
        },

        setHour: function(hour)
        {
            if (this.pause) return;

            // get current minute
            let minute = ( ! this.minute) ? '00' : this.minute;

            this.setTime(hour, minute);
        },

        isMinute: function(minute)
        {
            if (this.pause) return;

            return this.minute == minute;
        },

        setMinute: function(minute)
        {
            if (this.pause) return;

            // get current hour
            let hour = ( ! this.hour) ? '08' : this.hour;

            this.setTime(hour, minute);
        },

        setTime: function(hour, minute)
        {
            if (this.type == 'from') {
                this.form.from = hour + ':' + minute;
            } else {
                this.form.until = hour + ':' + minute;
            }
        },

        updateUserStats(item)
        {
            events.$emit('recalculate', item.date);

            if ( ! item.assigned) return;

            shared.getUser(item.user).stats = item.stats;
        },

        save(confirmed)
        {
            if (shared.hasApplications(this.item)) return;

            if (this.type == 'from' && this.form.from != null)
            {
                this.type = 'until';
                return;
            }

            if (this.timed)
            {
                this.$http.put(
                '/api/items/' + this.item.id + '/times',
                {
                    start: this.start,
                    end: this.end,
                    break: this.form.break,
                    confirmed: confirmed,
                })
                .then(response =>
                {
                    let key = _.findIndex(this.shared.items, {id: this.item.id});

                    // replace item
                    this.$set(this.shared.items, key, response.data.item);

                    // revalidate conflicts
                    shared.revalidate(response.data.revalidated);

                    this.updateUserStats(response.data.item);

                    this.$tools.close();
                })
                .catch(error =>
                {
                    let user = shared.getUser(this.item.user);

                    switch (error.response.data.error)
                    {
                        case 'ERR_EQUAL':
                            // start and end times must differ
                            this.$modal.show(this.$t('page.roster.time.error.headline'), this.$t('page.roster.time.error.ERR_EQUAL'));
                        break;

                        case 'ERR_NEGATIVE':
                            // duration cannot be negative
                            this.$modal.show(this.$t('page.roster.time.error.headline'), this.$t('page.roster.time.error.ERR_NEGATIVE'));
                        break;

                        case 'ERR_OVERLAP':
                        case 'ERR_EXISTING_FULL':
                            // cannot add hours because they overlap with another item
                            this.$modal.show(this.$t('page.roster.time.error.headline'), user.name + ' ' + this.$t('page.roster.time.error.ERR_OVERLAP'));
                        break;

                        case 'ERR_OVERLAP_REST':
                            // overlap in resting period of another item of user
                            this.$confirm.show(this.$t('page.roster.time.error.headline'), this.$t('confirm.resting.conflict', {name: user.name}),
                            {
                                confirm: () =>
                                {
                                    this.save('OVERRULE_REST');
                                },
                            });
                        break;

                        case 'ERR_CONFIRMED':
                            // cannot remove times because hours have already been confirmed
                            this.$modal.show(this.$t('page.roster.time.error.headline'), this.$t('page.roster.time.error.ERR_CONFIRMED'));

                            this.init();
                        break;

                        case 'ERR_UNAVAILABLE_LIMITED':
                            // user is limited available, schedule anyway?
                            this.$confirm.show(this.$t('page.roster.add.error.headline_limited'), user.name + ' ' + this.$t('page.roster.add.error.ERR_UNAVAILABLE_LIMITED'),
                            {
                                confirm: () =>
                                {
                                    this.save(true);
                                }
                            });
                        break;
                    }
                });
            }
        },

        remove(force, confirmed)
        {
            if (shared.hasApplications(this.item)) return;

            if (this.item.times && this.item.times.from && this.item.times.until)
            {
                // ------------------------------------------------------
                // remove times only

                this.$http.delete('/api/items/' + this.item.id + '/times', {
                    params: {
                        force: force,
                        confirmed: confirmed,
                    }
                })
                .then(response =>
                {
                    let key = _.findIndex(this.shared.items, {id: this.item.id});

                    if (response.data)
                    {
                        // replace item
                        this.$set(this.shared.items, key, response.data.item);

                        this.updateUserStats(response.data.item);

                        // revalidate conflicts
                        shared.revalidate(response.data.revalidated);
                    }
                    else
                    {
                        // remove userless, dutlyess item
                        this.$delete(this.shared.items, key);
                    }

                    this.$tools.close();
                })
                .catch(error =>
                {
                    let user = shared.getUser(this.item.user);

                    switch (error.response.data.error)
                    {
                        case 'ERR_SICK':
                            // cannot remove times, because assigned user has been marked sick
                            this.$modal.show(this.$t('page.roster.time.delete.error.headline'), this.$t('page.roster.sick.ERR_TIME.text'));
                        break;

                        case 'ERR_OVERLAP':
                            // cannot remove time, because full day item would overlap with other existing items
                            this.$modal.show(this.$t('page.roster.time.delete.error.headline'), user.name + ' ' + this.$t('page.roster.time.error.ERR_OVERLAP_REMOVAL'));
                        break;

                        case 'ERR_OVERLAP_REST':
                            // overlap in resting period of another item of user
                            this.$confirm.show(this.$t('page.roster.time.delete.error.headline'), this.$t('confirm.resting.conflict', {name: user.name}),
                            {
                                confirm: () =>
                                {
                                    this.remove(force, 'OVERRULE_REST');
                                },
                            });
                        break;

                        case 'ERR_CONFIRMED':
                            // cannot remove item, because hours have been approved
                            this.$modal.show(this.$t('page.roster.time.delete.error.headline'), this.$t('page.roster.shift.error.ERR_CONFIRMED'));

                            this.init();
                        break;

                        case 'ERR_OPEN_CHECKIN':
                            // item has an open checkin, needs to be checked-out first
                            this.$modal.show(this.$t('page.roster.item.delete.error.headline'), this.$t('page.roster.move.error.ERR_OPEN_CHECKIN'));
                        break;

                        case 'ERR_UNAVAILABLE_LIMITED':
                            // user is limited available, schedule anyway?
                            this.$confirm.show(this.$t('page.roster.add.error.headline_limited'), user.name + ' ' + this.$t('page.roster.add.error.ERR_UNAVAILABLE_LIMITED'),
                            {
                                confirm: () =>
                                {
                                    this.remove(force, true); // set confirmed = true;
                                }
                            });
                        break;
                    }
                });
            }
            else if (this.form.from != null || this.form.until != null)
            {
                this.reset();
            }
            else
            {
                // ------------------------------------------------------
                // remove item completely

                this.$confirm.show(this.$t('tools.remove_item.headline'), this.$t('tools.remove_item.text'),
                {
                    confirm: () =>
                    {
                        this.$http.delete('/api/items/' + this.item.id, {
                            params: {
                                force: force,
                                confirmed: confirmed,
                            }
                        })
                        .then(response =>
                        {
                            let key = _.findIndex(this.shared.items, {id: this.item.id});

                            // remove item
                            this.$delete(this.shared.items, key);

                            this.$tools.close();
                        })
                        .catch(error =>
                        {
                            switch (error.response.data.error)
                            {
                                case 'ERR_CONFIRMED':
                                    // hours have already been entered and confirmed
                                    this.$modal.show(this.$t('page.roster.item.delete.error.headline'), this.$t('page.roster.move.error.ERR_CONFIRMED'));
                                break;

                                case 'ERR_OPEN_CHECKIN':
                                    // item has an open checkin, needs to be checked-out first
                                    this.$modal.show(this.$t('page.roster.item.delete.error.headline'), this.$t('page.roster.move.error.ERR_OPEN_CHECKIN'));
                                break;

                                case 'ERR_HOURS':
                                    this.$confirm.show(this.$t('page.roster.item.has_hours.headline'), this.$t('page.roster.item.delete.ERR_HOURS'),
                                    {
                                        confirm: () =>
                                        {
                                            this.remove(true, confirmed); // set force = true;
                                        }
                                    });
                                break;

                                case 'ERR_UNAVAILABLE_LIMITED':
                                    // user is limited available, schedule anyway?
                                    this.$confirm.show(this.$t('page.roster.add.error.headline_limited'), user.name + ' ' + this.$t('page.roster.add.error.ERR_UNAVAILABLE_LIMITED'),
                                    {
                                        confirm: () =>
                                        {
                                            this.remove(force, true); // set confirmed = true;
                                        }
                                    });
                                break;
                            }
                        });
                    }
                });
            }
        },
    },
}
</script>



// WEBPACK FOOTER //
// Times.vue?02897864